import { render, staticRenderFns } from "./EntityChip.vue?vue&type=template&id=c8d79190"
import script from "./EntityChip.vue?vue&type=script&lang=js"
export * from "./EntityChip.vue?vue&type=script&lang=js"
import style0 from "./EntityChip.vue?vue&type=style&index=0&id=c8d79190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports